import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {PDFControlOptionsGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlOptionsGenerator";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";


export class FieldControlWrapper extends StoreBase{
    public Field:FieldControlOptions;

    protected LoadDefaultValues() {
        this.Field=null;
    }

    protected GetValueFromLoader(property: any, value: any): any {
        if(property=='Fields')
        {
            let fields=[];
            for(let item of value)
            {
                fields.push(PDFControlOptionsGenerator.GetControlOptions(item));
            }

            return fields;
        }
    }
}


export class ColumnItemOptions  extends StoreBase{
    @StoreDataType(FieldControlOptions)
    public Fields:PDFControlBaseOptions[];
    public Width:number;
    protected LoadDefaultValues() {
        this.Fields=[];
        this.Width=0;
    }


    protected GetValueFromLoader(property: any, value: any): any {
        if(property=='Fields')
        {
            let fields=[];
            for(let item of value)
            {
                fields.push(PDFControlOptionsGenerator.GetControlOptions(item));
            }

            return fields;
        }
    }


}

export class RowItemOptions  extends StoreBase{
    @StoreDataType(ColumnItemOptions)
    public Columns:ColumnItemOptions[];
    protected LoadDefaultValues() {
        this.Columns=[];
    }

}

export class TableItemOptions extends StoreBase{
    @StoreDataType(RowItemOptions)
    public Rows:RowItemOptions[];
    protected LoadDefaultValues() {
        this.Rows=[];
    }

}



export class TableControlOptions extends PDFControlBaseOptions{
    public TableItem:TableItemOptions;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.TableItem=new TableItemOptions().Merge();
        this.Type=ControlTypeEnum.Table;
    }
}
